import type {ToastManager} from '$lib/classes/stores/toast-manager.svelte';
import type {Status} from '$lib/classes/data/user-word';
import type {SentenceId, WordId} from '$lib/classes/data/_primitives';
import type {UserWordManager} from '$lib/classes/manager/user-word-manager.svelte';
import type {AccessLevelState} from '$lib/classes/state/access-level-state.svelte';
import {AccessLevel} from '$lib/classes/_enum/access-level';

export class UserActionProcessor {

    constructor(
        private readonly accessLevel: AccessLevelState,
        private readonly toastManager: ToastManager,
        private readonly userWordManager: UserWordManager
    ) { }

    private get userNeedsToUpgrade() {
        return this.accessLevel.current === AccessLevel.FreeTier
    }

    private promptToUpgrade() {
        this.toastManager.addUpgradeToast()
    }

    saveWord(id: WordId, status: Status | null) {
        if (this.userNeedsToUpgrade) {
            this.promptToUpgrade()
        } else {
            this.userWordManager.statusChangeRequest(id, status)
        }
    }

    saveSentence(wordId: WordId, sentenceId: SentenceId) {
        if (this.userNeedsToUpgrade) {
            this.promptToUpgrade()
        } else {
            this.userWordManager.sentenceChangeRequest(wordId, sentenceId)
        }
    }
}